export const INTERNAL_GRAPHQL_ENDPOINT =
  "https://the-honey-jar.squids.live/internal-squid@v7/api/graphql";

export const HENLO_GRAPHQL_ENDPOINT =
  "https://the-honey-jar.squids.live/henlo-squid@v11/api/graphql";

// Envio GraphQL endpoints (Hasura serves at /v1/graphql)
//
// `914708e` is the production-stable deployment that serves
// HenloBurnStats / HenloHolderStats / AquaberaUniqueBuilders. Operator
// confirmed (session-3): "The fallback is the right production one."
// Both PRIMARY and FALLBACK now point at it; the PRIMARY/FALLBACK split
// stays as a hook for future cutover without callers having to change.
export const ENVIO_GRAPHQL_ENDPOINT_PRIMARY =
  process.env.NEXT_PUBLIC_ENVIO_GRAPHQL_ENDPOINT ||
  "https://indexer.hyperindex.xyz/914708e/v1/graphql";

export const ENVIO_GRAPHQL_ENDPOINT_FALLBACK =
  "https://indexer.hyperindex.xyz/914708e/v1/graphql";

// Default export — production-stable Envio deployment.
export const ENVIO_GRAPHQL_ENDPOINT = ENVIO_GRAPHQL_ENDPOINT_FALLBACK;

export const OOGA_BOOGA_API_URL = "https://mainnet.api.oogabooga.io";
